import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import type { SocialPostRendition } from './social-post-preview-card';
import { postNaturalAspect, type PostCaptionMarks } from './social-post-look-parts';

export const INSTAGRAM_CAPTION_MARKS: PostCaptionMarks = { hashtags: true, mentions: false, urls: 'plain' };
export const INSTAGRAM_CAPTION_LIMIT = 250;
export const INSTAGRAM_REEL_CAPTION_LIMIT = 60;
export const INSTAGRAM_SQUARE = 1;
export const INSTAGRAM_CAROUSEL_ASPECT = 330 / 334;
export const INSTAGRAM_FEED_RENDITION: SocialPostRendition = { mode: 'fit', width: 660, height: 1174 };

export type InstagramLook = 'instagram-feed' | 'instagram-reel' | 'instagram-story';

export function instagramLook(card: Pick<SocialPostPreviewCardMetadata, 'postType' | 'media'>): InstagramLook | undefined {
  const { media, postType } = card;
  if (media.length === 0) {
    return undefined;
  }
  if (postType === 'story') {
    return 'instagram-story';
  }
  if (media.length === 1 && (postType === 'reel' || (postType !== 'carousel' && media[0].kind === 'video'))) {
    return 'instagram-reel';
  }
  return 'instagram-feed';
}

export function instagramHandle(card: Pick<SocialPostPreviewCardMetadata, 'accountName' | 'networkLabel'>): string {
  return card.accountName?.trim().replace(/^@+/, '') || card.networkLabel;
}

export function instagramFrameAspect(width: number, height: number): number {
  return postNaturalAspect(width, height) ?? INSTAGRAM_SQUARE;
}

export function instagramCarouselAspect(): number {
  return INSTAGRAM_CAROUSEL_ASPECT;
}
